import React, { Component } from 'react';
import intl from 'react-intl-universal';
import * as formStyles from 'components/Modals/ModalForms.scss';
import LoadingIndicator from '../../LoadingIndicator/LoadingIndicator';
import Modal from '../../Modal/ModalComponent/ModalComponent';
import * as styles from './DeviceCustomization.scss';

interface Props {
  closeModal: () => void;
  url: string;
}

interface State {
  displayLoadingIndicator: boolean;
  hasErrorState: boolean;
}

export class DeviceCustomization extends Component<Props, State> {

  state: State = {
    displayLoadingIndicator: true,
    hasErrorState: false
  };

  handleIFrameOnLoad = () => {
      this.setState({'displayLoadingIndicator': false});
  }

  handleIFrameMessage = (evt: MessageEvent) => {
    if (evt.data === 'closeDialog' || evt.data === 'SAVE_SUCCESS') {
      this.props.closeModal();
      return;
    }
    if (evt.data === 'SAVE_ERROR') {
      this.setState({hasErrorState: true});
    }
  }

  componentDidMount() {
    window.addEventListener(
      'message',
      this.handleIFrameMessage.bind(this),
      false);
  }

  componentWillUnmount() {
    window.removeEventListener(
      'message',
      this.handleIFrameMessage.bind(this),
      false);
  }

  render() {
    const {closeModal, url} = this.props;
    return (
      <Modal
        useSaveAsFormSubmit={false}
        hideSaveButton={true}
        closeModal={closeModal}
        hideCloseButton={true}
        hideFooter={true}
        className={styles.overrideModalClass}
      >
        <div className={styles.container}>
          <div className="contentBody">
            <form
              name="configHomeScreenForm"
              className="form"
              role="form"
              noValidate={true}
            >
              <div className={styles.homeScreenBody}>
                <iframe
                  onLoad={this.handleIFrameOnLoad}
                  name="phoneHDFrame"
                  id="phoneHDFrame"
                  className={this.state.displayLoadingIndicator ? styles.hidden : ''}
                  src={url}
                  allowFullScreen={false}
                />
                {this.state.displayLoadingIndicator ?
                  <LoadingIndicator />
                  : <span/>}
              </div>
            </form>
            {this.state.hasErrorState ?
              <div id="saveError" className={formStyles.error}>{intl.get('errorSavingCustomization')}</div>
              : <span/>}
          </div>
        </div>

      </Modal>
    );
  }

}

export default DeviceCustomization;
